export default __webpack_public_path__ + "static/media/eyebrows.4c73b706.svg";